export default {
    SignIn: 'Registrarse',
    Join: 'Crear una cuenta',
    ContactUs: 'Contactanos',
    savedHomes: 'Tus casas guardadas',
    MortgageCalculator: 'Tasas hipotecarias',
    HomesforSale: 'Casas en venta',
    HomesforRent: 'Casas en alquiler',
    ApartmentsForRent: 'Apartamentos en renta',
    OpenHouses: 'Casas en muestra',
    VirtualTours: 'Visitas virtuales',
    RecentPriceReductions: 'Casas rebajadas',
    SellYourHome: 'Vende tu casa',
    NoObligationCashOffer: 'Oferta en efectivo sin obligación',
    GetaHomeValuation: 'Cuánto vale tu casa',
    BecomeaMovotoAgent: 'Únete a nuestra red de agentes',
    Agent: 'Guia de agentes',
    savedSearches: 'Tus búsquedas',
    profile: 'Administra tu perfil',
    settings: 'Ajustes',
    HelpCenter: 'Centro de ayuda',
    meetAgentToday: 'Reúnase con un agente de bienes raíces hoy',
    call: 'Llamada',
    careers: 'Carreras',
    Faqs: 'FAQ',
    about: 'Acerca de',
    press: 'Prensa',
    feedback: 'Comentario',
    sitemap: 'Mapa',
    rentalsitemap: 'Mapa para rentar',
    blog: 'Movoto blog',
    guide: 'Movoto guía',
    CanadaSite: 'Canada',
    send: 'Enviar',
    getApp: 'Obtener la app de movoto',
    YourMovoto: 'Tu Movoto',
    FindaHome: 'Encuentra una casa',
    CustomerService: 'Servicio al cliente',
    AgentProfessionals: 'Agentes profesionales',
};
